const initialState = {
    data: null,
}
export const refreshTokenReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'REFRESHTOKEN_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'REFRESHTOKEN_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}

export default refreshTokenReducer;